import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // CRITICAL: Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/');
          return;
        }

        // Exchange session_id for user data
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const user = response.data;
        
        // Save user data to localStorage for session persistence
        localStorage.setItem('sponsiq_user', JSON.stringify(user));

        // Check if user should be registered as strategy creator
        const creatorMode = localStorage.getItem('creator_mode');
        const strategyNiche = localStorage.getItem('strategy_niche');

        if (creatorMode === 'strategy' && strategyNiche) {
          // Register as strategy creator
          try {
            await axios.post(
              `${API}/creators/register-strategy`,
              { niche: strategyNiche },
              { withCredentials: true }
            );
          } catch (regError) {
            console.log('Strategy registration:', regError.response?.data?.message || 'Processed');
          }
          
          // Clear stored data
          localStorage.removeItem('creator_mode');
          localStorage.removeItem('strategy_niche');
        } else {
          // Clear stored data
          localStorage.removeItem('creator_mode');
          localStorage.removeItem('pending_channel_id');
        }

        // Redirect to dashboard with user data
        navigate('/dashboard', { state: { user }, replace: true });
      } catch (error) {
        console.error('Auth failed:', error);
        navigate('/');
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
